export const POPUP_DEBIT_CARD_TYPE = {
  advancedCard: 1,
  additionInfo: 2,
  simpleCard: 3,
  bankAccount: 4,
  cashApp: 5
};
